
import { IClientAttributeModel } from '../../../../../../../Types/ClientModelTypes';
import EDCheckbox from '../../../../../../../BaseComponents/Checkboxes/EDCheckbox';
import EDBox from '../../../../../../../BaseComponents/EDBox/EDBox';

interface IProps {
  attribute: IClientAttributeModel;
  condition: boolean;
  setCondition: (newCondition: boolean) => void;
  isSmallScreen: boolean;
  disabled: boolean;
}

const FilterConditionValues: React.FC<
  React.PropsWithChildren<IProps>
> = props => (
  <EDBox
    sx={{
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <EDCheckbox
      label=" " // Om denna är blank flyttar sig checkboxen i sidled??
      checked={props.condition}
      onCheck={() => {
        props.setCondition(!props.condition);
      }}
      disabled={props.disabled}
    />
  </EDBox>
);

export default FilterConditionValues;
